import { FieldError, FieldValues, useFormContext } from "react-hook-form";
import { Alert, List, ListItem, Typography as T } from "@mui/material";

export const ListItemError = ({ error }: { error: string }) => {
  return (
    <ListItem disableGutters disablePadding sx={{ alignItems: "flex-start", gap: 0.75 }}>
      <T variant="caption" fontSize={14} color="attention.main">
        {error}
      </T>
    </ListItem>
  );
};

type FormError = {
  message: string;
  columnIndex?: number;
  columnField?: string;
};

// Extracts column-level validation error messages from the react-hook-form errors object
const extractMessages = (errors: FieldValues): FormError[] => {
  if (!errors) {
    return [];
  }

  const messages: FormError[] = [];

  Object.values(errors).forEach((fieldError) => {
    if (Array.isArray(fieldError)) {
      fieldError.forEach((col, i) => {
        const columnField = Object.keys(col)[0];
        const errorObj = Object.values(col)[0] as FieldError;

        if (errorObj?.message) {
          messages.push({ message: errorObj.message, columnIndex: i, columnField });
        }
      });
    }
  });

  return messages;
};

const IngestFormErrors = ({ loading = false }: { loading?: boolean }) => {
  const { formState } = useFormContext();
  const { errors } = formState;

  const formErrors = extractMessages(errors["metadata_config"] as FieldValues);

  if (loading || formErrors.length === 0) {
    return null;
  }

  return (
    <Alert severity="error" variant="outlined" sx={{ width: "100%" }}>
      <List disablePadding>
        {formErrors.map((error, i) => {
          let errorText = error.message;

          if (error.columnIndex !== undefined && error.columnField) {
            errorText = `Column ${error.columnIndex + 1} (${error.columnField}): ${error.message}`;
          }

          return <ListItemError key={i} error={errorText} />;
        })}
      </List>
    </Alert>
  );
};

export default IngestFormErrors;
